var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChargeConfirm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.49 17.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.2;}.cls-1,.cls-2,.cls-3,.cls-4{fill:#12574d;}.cls-5{fill:#bfd1cf;}.cls-2{opacity:.29;}.cls-6{fill:#dce6e5;}.cls-3{opacity:.17;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0.95,
    width: 23.54,
    height: 17.05,
    rx: 2.18,
    ry: 2.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 23.54,
    height: 17.05,
    rx: 2.18,
    ry: 2.18
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 2.48,
    width: 24.49,
    height: 3.91
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.01,
    y: 7.99,
    width: 11.94,
    height: 3.55,
    rx: 0.53,
    ry: 0.53
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15,
    y: 7.99,
    width: 6.52,
    height: 3.55,
    rx: 0.53,
    ry: 0.53
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.01,
    y: 12.38,
    width: 19.51,
    height: 0.84,
    rx: 0.15,
    ry: 0.15
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.01,
    y: 13.9,
    width: 6.12,
    height: 0.84,
    rx: 0.15,
    ry: 0.15
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeConfirm);
export default __webpack_public_path__ + "static/media/charge-confirm.ede24498.svg";
export { ForwardRef as ReactComponent };